import axios from "../../config/axiosConfig";
import { DB_BACKUP_REQUEST, DB_BACKUP_HISTORY_REQUEST, DB_BACKUP_REQUEST_SUCCESS, DB_BACKUP_REQUEST_FAILURE } from "../types";


// export const generateDbBackup = () => {
//   return async (dispatch, getState) => {
//     try {
//       dispatch({ type: DB_BACKUP_REQUEST });
//       const { auth } = getState();
//       let params = { userId: auth.user?.id, companyId: auth.company?.id, customerId: auth?.customer?.id };
      
//       return axios.get("/backup/download",{ params }).then((response) => {
//             if(response){
//               dispatch({ type: DB_BACKUP_REQUEST_SUCCESS });
//             }
//             return response;
//         }).catch((error) => {
//           console.error(error);
//           dispatch({ type: DB_BACKUP_REQUEST_FAILURE, error: error.message });
//           throw error;
//         });
//     } catch (error) {
//       console.error(error);
//       dispatch({ type: DB_BACKUP_REQUEST_FAILURE, error: error.message });
//       throw error;
//     }
//   };
// };
export const downloadDbBackup = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DB_BACKUP_REQUEST });

      const { auth } = getState();

      const params = {
        userId: auth.user?.id,
        companyId: auth.company?.id,
        customerId: auth?.customer?.id
      };

      const response = await axios.get("/backup/download", {
        params,
        responseType: "blob" // 🔥 MUST
      });

      // ✅ Create file from response
      const blob = new Blob([response.data]);

      // ✅ Extract filename from header
      let fileName = "backup.backup";
      const disposition = response.headers["content-disposition"];
      
      if (disposition) {
        const match = disposition.match(/filename="(.+)"/);
        if (match) fileName = match[1];
      }

      // ✅ Trigger download
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;

      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url);

      dispatch({ type: DB_BACKUP_REQUEST_SUCCESS });

      return true;

    } catch (error) {
      dispatch({ type: DB_BACKUP_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};

export const superAdminDownloadDbBackup = () => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();
      const params = {
        userId: auth.superUser?.id,
      };
      const response = await axios.get("/backup/downloadSuperAdminBackup", {
        params,
        responseType: "blob" // 🔥 MUST
      });
      // ✅ Create file from response
      const blob = new Blob([response.data]);

      // ✅ Extract filename from header
      let fileName = "backup.backup";
      const disposition = response.headers["content-disposition"];
      
      if (disposition) {
        const match = disposition.match(/filename="(.+)"/);
        if (match) fileName = match[1];
      }

      // ✅ Trigger download
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;

      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url);
      return true;

    } catch (error) {
      throw error;
    }
  };
};

// export const downloadDbBackup = (filePath, fileName) => {
//   return async (dispatch, getState) => {
//     try {
//       dispatch({ type: DB_BACKUP_REQUEST });
//       const { auth } = getState();
//       let params = { userId: auth.user?.id, companyId: auth.company?.id, customerId: auth?.customer?.id };
//       console.log('filePath<<', filePath);
      
//       return axios.get(filePath, { params }).then((response) => {
//             if(response) {
//               const blob = new Blob([response.data]);
//               const url = window.URL.createObjectURL(blob);

//               const link = document.createElement('a');
//               link.href = url;
//               link.download = fileName;

//               document.body.appendChild(link);
//               link.click();
//               link.remove();

//               window.URL.revokeObjectURL(url);
//               dispatch({ type: DB_BACKUP_REQUEST_SUCCESS });
//               return true;
//             }
//             return response;
//         }).catch((error) => {
//           console.error(error);
//           dispatch({ type: DB_BACKUP_REQUEST_FAILURE, error: error.message });
//           throw error;
//         });
//     } catch (error) {
//       console.error(error);
//       dispatch({ type: DB_BACKUP_REQUEST_FAILURE, error: error.message });
//       throw error;
//     }
//   };
// };

export const getLastCustomerBackupHistory = (include) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DB_BACKUP_REQUEST });
      const { auth } = getState();
      let params = { userId: auth.user?.id, companyId: auth.company?.id, customerId: auth?.user?.Customer_Id };
      if (include) {
        params = { ...params, include };
      }
      return axios.get("/backup/getLastCustomerBackupHistory", { params }).then((response) => {
        if (response.data) {
          dispatch({ type: DB_BACKUP_HISTORY_REQUEST, payload: response.data });
        }
      }).catch((error) => {
        console.error(error);
        dispatch({ type: DB_BACKUP_REQUEST_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error(error);
      dispatch({ type: DB_BACKUP_REQUEST_FAILURE, error: error.message });
    }
  };
};

export const getLastSuperAdminBackupHistory = (include) => {
  return async (dispatch, getState) => {
    try {
      const { auth } = getState();      
      let params = { userId: auth.superUser?.id };
      if (include) {
        params = { ...params, include };
      }
      return axios.get("/backup/getLastSuperAdminBackupHistory", { params }).then((response) => {
        return response?.data;
      }).catch((error) => {
        console.error(error);
        throw error; 
      });
    } catch (error) {
      console.error(error);
      throw error;
    }
  };
};
export const connectToGoogleDrive = () => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: DB_BACKUP_REQUEST });
      const { auth } = getState();
      let params = { userId: auth.user?.id, companyId: auth.company?.id, customerId: auth?.customer?.id };
      
      return axios.get("/backup/download",{ params }).then((response) => {
            if(response){
              dispatch({ type: DB_BACKUP_REQUEST_SUCCESS });
            }
            return response;
        }).catch((error) => {
          console.error(error);
          dispatch({ type: DB_BACKUP_REQUEST_FAILURE, error: error.message });
          throw error;
        });
    } catch (error) {
      console.error(error);
      dispatch({ type: DB_BACKUP_REQUEST_FAILURE, error: error.message });
      throw error;
    }
  };
};
